import { LabelOutlined } from "@clockwise/design-system/icons";
import { TagFilterEnum } from "@clockwise/schema";
import React from "react";
import { Chip } from "../../../../../../chip";
import { useUpdateEventSearchFilters } from "../../../../hooks/event-search-filters/useUpdateEventSearchFilters";

export const TagFilters = ({
  tags,
  eventSearchBlockId,
  conversationId,
  disabled = false,
}: {
  tags: TagFilterEnum[];
  eventSearchBlockId: string;
  conversationId: string;
  disabled?: boolean;
}) => {
  const { updateTagFilters } = useUpdateEventSearchFilters();

  const tagsString = tags.join(", ");

  const onDelete = () => {
    void updateTagFilters(eventSearchBlockId, conversationId, []);
  };
  return (
    <Chip
      sentiment="neutral"
      variant="outlined"
      startIcon={LabelOutlined}
      onDelete={onDelete}
      disabled={disabled}
    >
      {tagsString}
    </Chip>
  );
};
